module.exports = __webpack_public_path__ + "static/media/caret-filter-select.7bfe854a.svg";